import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
const routes = [
  // {
  //   path: '/',
  //   name: 'index',
  //   component: () => import('../views/index.vue')
  // },
  
  //手写 competeWrite.vue
  {
    path: '/',
    name: 'competeWrite',
    component: () => import('../views/competeWrite.vue')
  },
  // {
  //   path: '/compete',
  //   name: 'compete',
  //   component: () => import('../views/compete.vue')
  // },

  {
    path: '/news',
    name: 'news',
    component: () => import('../views/news.vue')
  },
  {
    path: '/webIndex',
    name: 'webIndex',
    component: () => import('../views/webIndex.vue')
  },
  {
    path: '/shulong365',
    name: 'shulong365',
    component: () => import('../views/shulong.vue')
  },
  {
    path: '/webShulong365',
    name: 'webShulong365',
    component: () => import('../views/webShulong.vue')
  },

 
  // {
  //   path: '/',
  //   name: 'lazySlideCaptcha',
  //   component: () => import('../views/lazySlideCaptcha.vue')
  // },
]
const createRouter = () =>new VueRouter({
  mode:"hash",
  routes:routes
})

// const orig = VueRouter.prototype.push;
// VueRouter.prototype.push = function push(location){ 
//   return orig.call(this,location).catch(err => err)
// }


const router = createRouter()

// 判断是否为移动端
function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

// 路由守卫：检测设备并重定向
router.beforeEach((to, from, next) => {
  const mobile = isMobile()

  // 移动端访问PC首页时，跳转到移动端页面
  if (mobile && (to.path === '/' || to.path === '/competeWrite')) {
    next('/webIndex')
  }else if(mobile && to.path === '/shulong365'){
    next('/webShulong365')
  }
  // // PC端访问移动端页面时，跳转到PC首页
  // else if (!mobile && to.path === '/webIndex') {
  //   next('/')
  // }
  else {
    next()
  }
})

export default router
